import _ from "lodash";
import { axiosInstance } from "./globals";
import * as userService from "./userService";

import {DataSourceRequest} from "@/model/DataSourceRequest";
import {DataSourceResult} from "@/model/DataSourceResult";


export async function getAll(): Promise<any[]> {
  return (await axiosInstance.get("/Areas/GetAreaList")).data;
}
